import { FlowType } from "../../../types/common";

export const layoutConfig = (flowType: FlowType) => {
  switch (flowType) {
    case "CAN_JOB_APPLY":
      return {
        outerClassName: "block",
        showHeading: {
          text: "Employment Details",
          className: "",
        },
        formClassName: "l1-mb-16 l1-mt-10 md:l1-mb-12 md:l1-mt-9",
        isShowLinkedInUrl: true,
        isShowCurrentSalary: true,
        isShowServingFields: true,
        isShowLinkedInConsent: true,
        showActionBtn: "compactAction",
        isScrollToTop: false,
      };
    case "EDIT_PROFILE":
      return {
        outerClassName:
          "no-scrollbar l1-relative l1-max-h-[calc(80vh-62px)] l1-min-h-max l1-overflow-y-scroll md:l1-h-max md:!l1-max-h-max md:l1-min-h-full md:l1-overflow-y-auto",
        formClassName: "l1-mb-36",
        isShowLinkedInUrl: false,
        isShowCurrentSalary: true,
        isShowServingFields: true,
        isShowLinkedInConsent: false,
        showActionBtn: "defaultAction",
        isScrollToTop: false,
      };
    case "PROFILE_NUDGE":
      return {
        outerClassName:
          "no-scrollbar l1-relative l1-max-h-[calc(80vh-62px)] l1-min-h-max l1-overflow-y-scroll md:l1-h-max md:!l1-max-h-max md:l1-min-h-full md:l1-overflow-y-auto",
        showHeading: {
          text: "Current Employment Details",
          className: "!l1-top-4 md:!l1-top-0",
        },
        formClassName:
          "l1-mb-20 l1-mt-10 l1-min-h-full md:l1-mb-12 md:l1-mt-10",
        isShowLinkedInUrl: true,
        isShowCurrentSalary: false,
        isShowServingFields: false, // if false , then it can also depend on experience level
        isCheckExperienceLevel: true, // if experienced then also we will hide serving fields
        isShowLinkedInConsent: true,
        showActionBtn: "compactAction",
        isScrollToTop: true,
      };
    case "L1_APOP":
      return {
        outerClassName: "block",
        showHeading: {
          text: "Employment Details",
          className: "",
        },
        formClassName: "l1-mb-16 l1-mt-10 md:l1-mb-12 md:l1-mt-9",
        isShowLinkedInUrl: true,
        isShowCurrentSalary: true,
        isShowServingFields: true,
        isShowLinkedInConsent: true,
        showActionBtn: "compactAction",
        isScrollToTop: false,
      };
    case "PROFILE_PAGE":
      return {
        outerClassName: "block",
        formClassName: "",
        isShowLinkedInUrl: false,
        isShowCurrentSalary: true,
        isShowServingFields: false,
        isShowLinkedInConsent: false,
        isShowDescription: true,
        isScrollToTop: false,
        jobTitle: "Job Title",
        showEmploymentType: true,
      };
    default:
      return {};
  }
};
